import GaugeVisualization from './GaugeVisualization';
import './GaugeVisualization.scss';

export { schema, uiSchema } from '../schemas/GaugeVisualizationSchema';
export default GaugeVisualization;
